<!-- @format -->

<register-company-tag>
<!--
  <div
    style="
      position: fixed;
      right: 32px;
      bottom: 32px;
      opacity: 0.6;
      background: #000;
      color: #fff;
      font-size: 16px;
      padding: 1em;
    "
  >
    <dl>
      <dt>開発用</dt>
      <dd>
        <a onclick="{ devDel }">申請情報削除</a>
      </dd>
      <dd>
        <a onclick="{ devConfirm }">set form</a>
      </dd>
    </dl>
  </div>
-->
  <template if="{ state.firstLoad }">
    <register-company-form-tag
      if="{!state.isConfirm && !state.applyingData}"
      errors="{ state.errors }"
      prefs="{ state.prefs }"
      confirmation="{confirmation}"
    ></register-company-form-tag>

    <register-company-confirm-tag
      if="{state.isConfirm && !state.applyingData}"
      params="{ state.params }"
      prefs="{ state.prefs }"
      back="{back}"
      fetchApplyingData="{fetchApplyingData}"
      MenuApi="{MenuApi}"
    ></register-company-confirm-tag>

    <!-- <register-company-complete
      if="{state.applyingData}"
      applyingData="{state.applyingData}"
      on-confirm="{ onApply }"
      del="{del}"
    ></register-company-applying-tag> -->

    <register-company-complete
      if="{state.applyingData}"
    ></register-company-complete>
  </template>

  <script>
    import di from "dependeny-injection";
    import registerCompanyComplateTag from "@tags/pages/menu/register-company-complete.riot";
    import registerCompanyApplyingTag from "@tags/pages/menu/register-company-applying.riot";
    import registerCompanyConfirmTag from "@tags/pages/menu/register-company-confirm.riot";
    import registerCompanyFormTag from "@tags/pages/menu/register-company-form.riot";

    export default {
      components: {
        "register-company-complete": registerCompanyComplateTag,
        "register-company-confirm-tag": registerCompanyConfirmTag,
        "register-company-applying-tag": registerCompanyApplyingTag,
        "register-company-form-tag": registerCompanyFormTag,
      },
      state: {
        firstLoad: false,
        applyingData: false,
        isConfirm: false,
        params: {},
        errors: {},
      },
      fetchApplyingData() {
        this.MenuApi.request("registerCompany", "fetch").then((data) =>
          this.onApplyingDataUpdate(data)
        );
      },
      back() {
        this.update({ isConfirm: false });
      },
      async confirmation(params) {
        try {
          const res = await this.MenuApi.request(
            "registerCompany",
            "register",
            { phase: "confirm", ...params }
          );
          this.update({ isConfirm: true, params });
        } catch (e) {
          if (e.message == "invalid") {
            this.update({ errors: e.data });
            const container = window.document.querySelector(
              ".container_contents"
            );
            const top =
              this.$("p.error").previousElementSibling.getBoundingClientRect()
                .y + container.scrollTop;
            container.scrollTo({ top: top - 8, behavior: "smooth" });
            di.toast.push("入力に問題があります", "negative");
          } else {
            di.toast.push(e.message, "negative");
          }
        }
      },
      onApplyingDataUpdate(data) {
        this.update({
          applyingData: data.data,
          prefs: data.prefs,
          firstLoad: true,
        });
      },
      onBeforeMount() {
        this.MenuApi = di.createApi();
        this.fetchApplyingData();
      },

      //devDel() {
      //  this.MenuApi.request("registerCompany", "delete").then(() => {
      //    this.update({ applyingData: false, isConfirm: false, params: {} });
      //  });
      //},
      //devConfirm() {
      //  const params = {
      //    company_name: "CROCO株式会社",
      //    company_kana: "くろこかぶしきがいしゃ",
      //    representative: "栗田 佳典",
      //    zip: "1510053",
      //    pref: "13",
      //    address1: "渋谷区代々木4-33-10",
      //    address2: "トーシンビル6階",
      //    url: "https://cro-co.co.jp/",
      //    tel: "0344059235",
      //    content:
      //      "・コンテンツマーケティング（調査・解析・企画・制作・運用）事業\n・マーケティングツールの開発・提供\n・ライター支援ツールの開発・提供",
      //    established_year: "2015",
      //    established_month: "3",
      //    capital: "2億4,511万",
      //    listed: "0",
      //    code: "0123456789012",
      //  };
      //  for (const [name, value] of Object.entries(params)) {
      //    const e = this.$(`[name="${name}"]`);
      //    if (e.onchange) {
      //      e.onchange({ target: { value } });
      //    } else if (e.oninput) {
      //      e.oninput({ target: { value } });
      //    } else if (e.onkeyup) {
      //      e.onkeyup({ target: { value } });
      //    }
      //    e.value = value;
      //  }
      //},
    };
  </script>
</register-company-tag>
